// Original products data
const originalProducts = [
  {
    id: 1,
    name: "Azure River Dining Table",
    category: "dining",
    price: 3200,
    originalPrice: 3800,
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&fit=crop"
    ],
    description: "Stunning 8-person dining table featuring a mesmerizing blue epoxy river flowing through premium walnut wood.",
    longDescription: "This masterpiece combines the natural beauty of live-edge walnut with the ethereal flow of azure epoxy resin. Each table is unique, showcasing the natural grain patterns while the translucent blue river creates depth and movement. Perfect for bringing family and friends together around a truly one-of-a-kind centerpiece.",
    features: [
      "Live Edge Black Walnut",
      "Deep Pour Epoxy River",
      "Steel Hairpin Legs",
      "UV Resistant Finish",
      "Seats 8 People",
      "Food Safe Surface"
    ],
    specifications: {
      dimensions: "96\" L x 42\" W x 30\" H",
      weight: "180 lbs",
      material: "Walnut Wood + Epoxy Resin",
      finish: "Satin Polyurethane",
      warranty: "5 Years"
    },
    inStock: true,
    featured: true,
    rating: 4.9,
    reviews: 47
  },
  {
    id: 7,
    name: "Ocean Depths Coffee Table",
    category: "coffee",
    price: 2400,
    originalPrice: 2800,
    image: "/images/products/WhatsApp Image 2025-06-29 at 13.21.08 (1).jpeg",
    images: [
      "/images/products/WhatsApp Image 2025-06-29 at 13.21.08 (1).jpeg",
      "/images/products/WhatsApp Image 2025-06-29 at 13.21.09.jpeg"
    ],
    description: "Mesmerizing oval coffee table with deep blue ocean-inspired epoxy and natural wood legs, capturing the essence of underwater currents.",
    longDescription: "This stunning oval coffee table features a captivating deep blue epoxy surface that mimics the mysterious depths of the ocean. The translucent resin creates fascinating depth effects with swirling patterns that change with lighting throughout the day. Supported by elegant curved wooden legs, this piece serves as both functional furniture and conversation-starting art.",
    features: [
      "Oval Live Edge Design",
      "Deep Ocean Blue Epoxy",
      "Curved Walnut Legs",
      "UV Resistant Coating",
      "Heat Resistant Surface",
      "Handcrafted Artistry"
    ],
    specifications: {
      dimensions: "54\" L x 32\" W x 18\" H",
      weight: "95 lbs",
      material: "Walnut Wood + Ocean Blue Epoxy",
      finish: "High Gloss Marine Grade",
      warranty: "4 Years"
    },
    inStock: true,
    featured: true,
    rating: 4.8,
    reviews: 23
  },
  {
    id: 8,
    name: "Emerald River Dining Surface",
    category: "dining",
    price: 3800,
    originalPrice: 4200,
    image: "/images/products/WhatsApp Image 2025-06-29 at 13.21.08.jpeg",
    images: [
      "/images/products/WhatsApp Image 2025-06-29 at 13.21.08.jpeg"
    ],
    description: "Rectangular dining table featuring stunning emerald and teal epoxy rivers flowing through rich wood sections with golden accents.",
    longDescription: "This remarkable dining surface showcases the perfect marriage of natural wood beauty and artistic resin work. Multiple flowing epoxy sections in emerald and teal create organic river patterns throughout the piece, while metallic gold accents add luxury touches. The rich wood sections provide beautiful contrast and warmth to the cool resin tones.",
    features: [
      "Multi-River Design",
      "Emerald & Teal Epoxy",
      "Metallic Gold Accents",
      "Premium Hardwood Base",
      "Food Safe Finish",
      "Custom Lighting Compatible"
    ],
    specifications: {
      dimensions: "84\" L x 42\" W x 30\" H",
      weight: "160 lbs",
      material: "Mixed Hardwood + Colored Epoxy",
      finish: "Satin Marine Grade",
      warranty: "5 Years"
    },
    inStock: true,
    featured: true,
    rating: 4.9,
    reviews: 18
  },
  {
    id: 9,
    name: "Azure Swirl Coffee Table",
    category: "coffee",
    price: 1950,
    originalPrice: 2300,
    image: "/images/products/WhatsApp Image 2025-06-29 at 13.21.09.jpeg",
    images: [
      "/images/products/WhatsApp Image 2025-06-29 at 13.21.09.jpeg"
    ],
    description: "Round coffee table with mesmerizing blue and white swirl patterns creating a marble-like effect in crystal-clear epoxy.",
    longDescription: "This captivating round coffee table features an artistic swirl pattern in blues and whites that creates a stunning marble-like effect. The epoxy resin captures light beautifully, creating depth and movement that changes throughout the day. Perfect as a centerpiece for modern living spaces, this table brings both function and artistic beauty to your home.",
    features: [
      "Round Design",
      "Marble Swirl Effect",
      "Blue & White Artistry",
      "Crystal Clear Epoxy",
      "Stable Base Design",
      "Easy Maintenance"
    ],
    specifications: {
      dimensions: "36\" Diameter x 18\" H",
      weight: "75 lbs",
      material: "Engineered Base + Artistic Epoxy",
      finish: "Ultra High Gloss",
      warranty: "3 Years"
    },
    inStock: true,
    featured: false,
    rating: 4.7,
    reviews: 31
  },
  {
    id: 10,
    name: "Coastal Wave Console",
    category: "console",
    price: 2800,
    originalPrice: 3200,
    image: "/images/products/WhatsApp Image 2025-06-29 at 13.21.09 (1).jpeg",
    images: [
      "/images/products/WhatsApp Image 2025-06-29 at 13.21.09 (1).jpeg"
    ],
    description: "Modern console table with dramatic coastal-inspired epoxy patterns in turquoise and white with sleek metal base.",
    longDescription: "Inspired by coastal waters and sandy shores, this contemporary console table features flowing epoxy patterns in turquoise and cream that evoke the feeling of waves meeting shore. The dramatic resin work is supported by a clean, minimalist metal base that doesn't compete with the artistic top. Perfect for entryways, behind sofas, or as a statement piece in any modern space.",
    features: [
      "Coastal Wave Design",
      "Turquoise & Cream Epoxy",
      "Modern Metal Base",
      "Large Surface Area",
      "Scratch Resistant",
      "Contemporary Styling"
    ],
    specifications: {
      dimensions: "72\" L x 16\" W x 32\" H",
      weight: "110 lbs",
      material: "Steel Base + Artistic Epoxy Top",
      finish: "Powder Coated Base, Glossy Top",
      warranty: "4 Years"
    },
    inStock: true,
    featured: true,
    rating: 4.8,
    reviews: 15
  },
  {
    id: 11,
    name: "Marble Wave Side Table",
    category: "accent",
    price: 1400,
    originalPrice: 1650,
    image: "/images/products/WhatsApp Image 2025-06-29 at 13.21.09 (2).jpeg",
    images: [
      "/images/products/WhatsApp Image 2025-06-29 at 13.21.09 (2).jpeg"
    ],
    description: "Unique triangular side table featuring dramatic marble-inspired patterns in green, white, and black with geometric design.",
    longDescription: "This striking triangular side table showcases bold marble-inspired patterns in rich greens, crisp whites, and dramatic blacks. The geometric form creates visual interest while the flowing epoxy patterns add organic movement. The unique shape makes it perfect for tight spaces, corner placements, or as an artistic accent piece that doubles as functional furniture.",
    features: [
      "Triangular Geometric Form",
      "Marble-Inspired Patterns",
      "Green, White & Black Design",
      "Space-Efficient Shape",
      "Artistic Statement Piece",
      "Durable Construction"
    ],
    specifications: {
      dimensions: "24\" L x 20\" W x 22\" H",
      weight: "45 lbs",
      material: "Composite Base + Artistic Epoxy",
      finish: "Semi-Gloss Protective",
      warranty: "3 Years"
    },
    inStock: true,
    featured: false,
    rating: 4.6,
    reviews: 12
  },
  {
    id: 2,
    name: "Ocean Wave Coffee Table",
    category: "coffee",
    price: 1850,
    originalPrice: 2200,
    image: "https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&fit=crop"
    ],
    description: "Mesmerizing coffee table capturing the essence of ocean waves in crystal-clear epoxy.",
    longDescription: "Inspired by the rhythmic motion of ocean waves, this coffee table features layers of blue and white epoxy that create depth and movement. The oak base provides stability while the wave-like patterns in the resin surface capture light beautifully throughout the day.",
    features: [
      "White Oak Base",
      "Multi-layer Epoxy Waves",
      "Tempered Glass Protection",
      "Modern Minimalist Design",
      "Scratch Resistant"
    ],
    specifications: {
      dimensions: "48\" L x 24\" W x 18\" H",
      weight: "85 lbs",
      material: "Oak Wood + Epoxy Resin",
      finish: "High Gloss",
      warranty: "3 Years"
    },
    inStock: true,
    featured: true,
    rating: 4.8,
    reviews: 32
  },
  {
    id: 3,
    name: "Forest Stream Side Table",
    category: "accent",
    price: 950,
    originalPrice: 1200,
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&fit=crop"
    ],
    description: "Elegant accent piece with emerald epoxy stream design flowing through natural elm wood.",
    longDescription: "This charming side table brings the tranquility of a forest stream into your living space. The emerald green epoxy flows naturally through the elm wood grain, creating a sense of movement and life that complements any room's decor.",
    features: [
      "Natural Elm Wood",
      "Emerald Epoxy Stream",
      "Compact Design",
      "Handcrafted Details",
      "Eco-Friendly Finish"
    ],
    specifications: {
      dimensions: "20\" L x 16\" W x 24\" H",
      weight: "35 lbs",
      material: "Elm Wood + Epoxy Resin",
      finish: "Natural Oil",
      warranty: "2 Years"
    },
    inStock: true,
    featured: false,
    rating: 4.7,
    reviews: 23
  },
  {
    id: 4,
    name: "Midnight Galaxy Console",
    category: "console",
    price: 2400,
    originalPrice: 2800,
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?w=800&h=600&fit=crop"
    ],
    description: "Dramatic console table with starlit epoxy galaxy effect and integrated LED lighting.",
    longDescription: "Transform your entryway or living room with this stunning console that captures the mystery of deep space. Purple and indigo epoxy swirls with mica powder create a galaxy effect, while optional LED lighting enhances the cosmic beauty.",
    features: [
      "Premium Cherry Wood",
      "Galaxy Mica Powder Effect",
      "Integrated LED Lighting",
      "Cable Management",
      "Soft-Close Drawers"
    ],
    specifications: {
      dimensions: "60\" L x 16\" W x 32\" H",
      weight: "120 lbs",
      material: "Cherry Wood + Epoxy Resin",
      finish: "Semi-Gloss",
      warranty: "4 Years"
    },
    inStock: true,
    featured: true,
    rating: 4.9,
    reviews: 18
  },
  {
    id: 5,
    name: "Crystal Clear Bar Top",
    category: "bar",
    price: 4500,
    originalPrice: 5200,
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop"
    ],
    description: "Professional-grade bar counter with crystal-clear epoxy finish and commercial durability.",
    longDescription: "Designed for both residential and commercial use, this bar top combines the warmth of maple wood with the pristine clarity of food-safe epoxy. Built to withstand heavy use while maintaining its stunning appearance for years to come.",
    features: [
      "Premium Maple Base",
      "Food-Safe Epoxy Coating",
      "Commercial Grade Durability",
      "Stain Resistant Surface",
      "Easy Maintenance",
      "Custom Sizing Available"
    ],
    specifications: {
      dimensions: "96\" L x 24\" W x 4\" Thick",
      weight: "200 lbs",
      material: "Maple Wood + Food-Safe Epoxy",
      finish: "Ultra High Gloss",
      warranty: "7 Years Commercial"
    },
    inStock: true,
    featured: false,
    rating: 4.8,
    reviews: 12
  },
  {
    id: 6,
    name: "Sunset Horizon Desk",
    category: "office",
    price: 2100,
    originalPrice: 2500,
    image: "https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?w=800&h=600&fit=crop"
    ],
    description: "Inspiring workspace featuring warm sunset gradient epoxy with built-in cable management.",
    longDescription: "Create an inspiring work environment with this stunning desk that captures the warm colors of a sunset horizon. The gradient epoxy design transitions from deep orange to golden yellow, energizing your workspace while maintaining professional elegance.",
    features: [
      "Black Walnut Base",
      "Sunset Gradient Epoxy",
      "Built-in Cable Management",
      "Ergonomic Design",
      "Scratch Resistant Surface"
    ],
    specifications: {
      dimensions: "60\" L x 30\" W x 29\" H",
      weight: "110 lbs",
      material: "Walnut Wood + Gradient Epoxy",
      finish: "Matte Protective Coating",
      warranty: "3 Years"
    },
    inStock: false,
    featured: false,
    rating: 4.6,
    reviews: 15
  }
];

// Function to get all products (original + admin-added)
const getAllProducts = () => {
  // Get admin products from localStorage
  const adminProducts = localStorage.getItem('adminProducts');
  
  if (adminProducts) {
    try {
      const parsedAdminProducts = JSON.parse(adminProducts);
      
      // Combine original products with admin products
      // Remove duplicates by ID (admin products override original ones)
      const combinedProducts = [...originalProducts];
      
      parsedAdminProducts.forEach(adminProduct => {
        const existingIndex = combinedProducts.findIndex(p => p.id === adminProduct.id);
        if (existingIndex !== -1) {
          // Replace existing product
          combinedProducts[existingIndex] = adminProduct;
        } else {
          // Add new product
          combinedProducts.push(adminProduct);
        }
      });
      
      return combinedProducts;
    } catch (error) {
      console.error('Error parsing admin products:', error);
      return originalProducts;
    }
  }
  
  return originalProducts;
};

// Export the combined products
export const products = getAllProducts();

export const categories = [
  { 
    id: 'all', 
    name: 'All Products', 
    count: products.length,
    description: 'Browse our complete collection of handcrafted resin furniture'
  },
  { 
    id: 'dining', 
    name: 'Dining Tables', 
    count: products.filter(p => p.category === 'dining').length,
    description: 'Stunning dining tables that bring families together'
  },
  { 
    id: 'coffee', 
    name: 'Coffee Tables', 
    count: products.filter(p => p.category === 'coffee').length,
    description: 'Eye-catching centerpieces for your living room'
  },
  { 
    id: 'accent', 
    name: 'Accent Tables', 
    count: products.filter(p => p.category === 'accent').length,
    description: 'Perfect finishing touches for any space'
  },
  { 
    id: 'console', 
    name: 'Console Tables', 
    count: products.filter(p => p.category === 'console').length,
    description: 'Elegant entryway and hallway solutions'
  },
  { 
    id: 'bar', 
    name: 'Bar Tops', 
    count: products.filter(p => p.category === 'bar').length,
    description: 'Commercial-grade surfaces for entertaining'
  },
  { 
    id: 'office', 
    name: 'Office Furniture', 
    count: products.filter(p => p.category === 'office').length,
    description: 'Inspiring workspaces for productivity and creativity'
  }
];

export const featuredProducts = products.filter(product => product.featured);

export const getProductById = (id) => {
  return products.find(product => product.id === parseInt(id));
};

export const getProductsByCategory = (category) => {
  if (category === 'all') return products;
  return products.filter(product => product.category === category);
};